const mainConfig = {
  id: 'root',
  context: {
    games: {},
    rpVisible: true,
    searchRpVisible: true,
    rpFirstLoad: true,
    user: {
      loggedIn: false,
      userCurrency: '',
      userAccountNumber: '',
      userStatus: 'non-customer',
      userToken: '',
    },
    loginModalState: {
      isOpened: false,
      isAwaitingLogin: false,
    },
    gameToLaunch: null,
    pendingAccountEvents: [],
    controllersData: {},
  },
  initial: 'checkingForRedirection',
  states: {
    checkingForRedirection: {
      always: [
        {
          cond: 'shouldRedirectUrl',
          target: 'redirecting',
        },
        {
          target: 'main',
        },
      ],
    },
    redirecting: {
      type: 'atomic',
      invoke: {
        src: 'redirectUrl',
        onDone: {
          target: 'main',
        },
        onError: {
          target: 'main',
        },
      },
    },
    main: {
      type: 'parallel',
      states: {
        session: {
          invoke: {
            src: 'watchSession',
          },
          initial: 'initializing',
          states: {
            initializing: {
              on: {
                SESSION_STATE_LOGGED_IN: {
                  target: 'userLoggedIn',
                  actions: [
                    {
                      type: 'save',
                      data: {
                        user: '$event.data',
                        sessionResolved: true,
                      },
                      meta: {
                        selectors: ['$action.data.user'],
                      },
                    },
                  ],
                },
                SESSION_STATE_LOGGED_OUT: {
                  target: 'userLoggedOut',
                  actions: [
                    {
                      type: 'save',
                      data: {
                        user: '$event.data',
                        sessionResolved: true,
                      },
                      meta: {
                        selectors: ['$action.data.user'],
                      },
                    },
                  ],
                },
              },
            },
            userLoggedOut: {
              entry: 'manageGameLaunchCallbackMode',
              invoke: {
                src: 'setCallbackModeForComponents',
                onDone: {
                  actions: [
                    {
                      type: 'batchLayoutOperations',
                      data: '$event.data.updates',
                      meta: {
                        selectors: ['$action.data'],
                      },
                    },
                  ],
                },
              },
              on: {
                SESSION_STATE_LOGGED_IN: {
                  target: 'userLoggedIn',
                  actions: [
                    {
                      type: 'save',
                      data: {
                        user: '$event.data',
                      },
                      meta: {
                        selectors: ['$action.data.user'],
                      },
                    },
                  ],
                },
              },
            },
            userLoggedIn: {
              type: 'parallel',
              states: {
                manageUserRelatedContent: {
                  entry: 'updateUserTrackingInfo',
                  initial: 'fetchPageForLoggedInUser',
                  states: {
                    fetchPageForLoggedInUser: {
                      always: [
                        {
                          target: 'fetchAuthToken',
                          cond: 'isAppInitilaized_InternalTokenVariant',
                        },
                        {
                          target: 'updateAuthData',
                          cond: 'isAppInitilaized_ExternalTokenVariant',
                        },
                        {
                          target: 'idle',
                        },
                      ],
                    },
                    fetchAuthToken: {
                      invoke: {
                        src: 'fetchAuthToken',
                        onDone: [
                          {
                            target: 'updateAuthData',
                            actions: ['saveAuthToken'],
                          },
                        ],
                      },
                    },
                    updateAuthData: {
                      always: [
                        {
                          target: 'idle',
                          actions: [
                            { type: 'save', data: { initialRequest: true } },
                            'layout_changePageId',
                          ],
                          cond: 'areAnySavedSegments',
                        },
                        {
                          target: 'idle',
                          actions: [
                            'categories_refetch',
                            'categories_reload',
                            'layout_reload',
                            'layout_changePageId',
                          ],
                          cond: 'isDifferentCurrency',
                        },
                        {
                          target: 'idle',
                          actions: [
                            'personalized_banners_refetch',
                            'layout_reload',
                            'layout_changePageId',
                          ],
                          cond: 'arePersonalizedBannersAvailable',
                        },
                        {
                          target: 'idle',
                          actions: [
                            'layout_reload',
                            'layout_changePageId',
                            'saveInfoAccountInfo',
                            'trackPendingAccountEvents',
                          ],
                        },
                      ],
                    },
                    idle: {
                      entry: 'manageGameLaunchCallbackMode',
                      invoke: {
                        src: 'setCallbackModeForComponents',
                        onDone: [
                          {
                            target: 'watchSessionRelatedEvents',
                            actions: [
                              {
                                type: 'batchLayoutOperations',
                                data: '$event.data.updates',
                                meta: {
                                  selectors: ['$action.data'],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    watchSessionRelatedEvents: {
                      entry: ['fetchRecentlyPlayed'],
                      invoke: [{ src: 'watchSessionTokenExpirationTime' }],
                      initial: 'idle',
                      states: {
                        idle: {
                          on: {
                            REFRESH_SESSION_TOKEN: [
                              {
                                actions: ['fetchRefreshedSessionToken'],
                                cond: 'isInternalAuthTokenVariant',
                              },
                              {
                                actions: ['saveRefreshedAuthToken'],
                              },
                            ],
                            SESSION_STATE_LOGGED_OUT: [
                              {
                                cond: 'currentlyOnRecentlyPlayedPage',
                                target: '#root.main.session.userLoggedOut',
                                actions: [
                                  {
                                    type: 'savePreviousUser',
                                  },
                                  {
                                    type: 'save',
                                    data: {
                                      user: '$event.data',
                                    },
                                    meta: {
                                      selectors: ['$action.data.user'],
                                    },
                                  },
                                  'rp_rerender',
                                ],
                              },
                              {
                                cond: 'arePersonalizedBannersAvailable',
                                target: '#root.main.session.userLoggedOut',
                                actions: [
                                  {
                                    type: 'savePreviousUser',
                                  },
                                  {
                                    type: 'save',
                                    data: {
                                      user: '$event.data',
                                    },
                                    meta: {
                                      selectors: ['$action.data.user'],
                                    },
                                  },
                                  'layout_changePageId',
                                  'rp_rerender',
                                ],
                              },
                              {
                                cond: 'isDifferentCurrency',
                                target: '#root.main.session.userLoggedOut',
                                actions: [
                                  {
                                    type: 'savePreviousUser',
                                  },
                                  {
                                    type: 'save',
                                    data: {
                                      user: '$event.data',
                                    },
                                    meta: {
                                      selectors: ['$action.data.user'],
                                    },
                                  },
                                  'layout_changePageId',
                                  'rp_rerender',
                                ],
                              },
                              {
                                target: '#root.main.session.userLoggedOut',
                                actions: [
                                  {
                                    type: 'savePreviousUser',
                                  },
                                  {
                                    type: 'save',
                                    data: {
                                      user: '$event.data',
                                    },
                                    meta: {
                                      selectors: ['$action.data.user'],
                                    },
                                  },
                                  'layout_reload',
                                  'rp_rerender',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                },
                managePhrases: {
                  initial: 'idle',
                  states: {
                    idle: {
                      always: [
                        {
                          target: 'addPendingPhraseToRecentPhrases',
                          cond: 'isPhrasePendingToAddToRecentPhrases',
                        },
                      ],
                    },
                    addPendingPhraseToRecentPhrases: {
                      invoke: {
                        src: 'fetchRecentPhrases',
                        onDone: {
                          actions: [
                            {
                              type: 'save',
                              data: {
                                recentPhrases: '$event.data.recentPhrases',
                              },
                              meta: {
                                selectors: ['$action.data.recentPhrases'],
                              },
                            },
                            {
                              type: 'updatePhrases',
                            },
                            {
                              type: 'savePhrase',
                            },
                          ],
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
        watchSessionToken: {
          initial: 'init',
          states: {
            init: {
              on: {
                FETCH_AUTH_TOKEN: {
                  target: 'fetchNewAuthToken',
                },
                FETCH_REFRESHED_AUTH_TOKEN: {
                  target: 'fetchRefreshedAuthToken',
                },
                FETCH_REFRESHED_AUTH_TOKEN_WITH_DEPENDENCIES: {
                  target: 'fetchRefreshedAuthTokenWithDependencies',
                },
              },
            },
            fetchNewAuthToken: {
              invoke: {
                src: 'fetchAuthToken',
                onDone: [
                  {
                    target: 'init',
                    actions: ['saveAuthToken'],
                  },
                ],
              },
            },
            fetchRefreshedAuthToken: {
              invoke: {
                src: 'fetchRefreshedAuthToken',
                onDone: [
                  {
                    target: 'init',
                    actions: 'fetchAuthToken',
                    cond: 'isAuthTokenExpired',
                  },
                  {
                    target: 'init',
                    actions: ['saveRefreshedAuthToken'],
                  },
                ],
              },
            },
            fetchRefreshedAuthTokenWithDependencies: {
              invoke: {
                src: 'fetchRefreshedAuthToken',
                onDone: [
                  {
                    target: 'init',
                    actions: ['saveRefreshedAuthToken', 'fetchRecentlyPlayed'],
                    cond: 'isAuthTokenInitialSetup',
                  },
                  {
                    target: 'init',
                    actions: ['saveRefreshedAuthToken', 'fetchRecentlyPlayed'],
                  },
                ],
              },
            },
          },
        },
        watchRecentlyPlayed: {
          initial: 'init',
          states: {
            init: {
              on: {
                UPDATE_RECENTLY_PLAYED: {
                  target: 'updateRecentlyPlayed',
                },
                UPDATE_RECENTLY_PLAYED_AFTER_DELAY: {
                  target: 'updateRecentlyPlayedAfterDelay',
                },
                CLEAR_RECENTLY_PLAYED: {
                  target: 'clearRecentlyPlayed',
                },
              },
            },
            updateRecentlyPlayedAfterDelay: {
              invoke: {
                src: 'watchRecentlyPlayedTimer',
              },
              on: {
                RECENTLY_PLAYED_TO_UPDATE: {
                  target: 'updateRecentlyPlayed',
                },
              },
            },
            updateRecentlyPlayed: {
              invoke: {
                src: 'fetchRecentlyPlayedGames',
                onDone: [
                  {
                    target: 'init',
                    actions: ['initAuthTokenRefresh', 'updateRetryStatus'],
                    cond: 'isResponseInvalid_InternalAuthTokenVariant',
                  },
                  {
                    target: 'init',
                    actions: ['updateRecentlyPlayedGames', 'rp_rerender'],
                  },
                ],
              },
            },
            clearRecentlyPlayed: {
              always: {
                target: 'init',
                actions: ['clearRecentlyPlayedGames', 'rp_rerender'],
              },
            },
          },
        },
        watchUserAction: {
          invoke: {
            src: 'watchUserAction',
          },
        },
        loginModal: {
          invoke: {
            src: 'watchLoginModalActions',
            cond: 'isHeaderInVisibleMode',
          },
          on: {
            LOGIN_MODAL_STATE_AWAIT_LOGIN: {
              actions: [
                {
                  type: 'save',
                  data: {
                    loginModalState: {
                      isAwaitingLogin: true,
                    },
                  },
                },
              ],
            },
            SESSION_STATE_LOGGED_IN: {
              actions: [
                {
                  type: 'save',
                  data: {
                    loginModalState: {
                      isAwaitingLogin: false,
                    },
                  },
                },
              ],
            },
            SESSION_STATE_LOGGED_OUT: {
              actions: [
                {
                  type: 'save',
                  data: {
                    isAccountInfoAvailable: false,
                  },
                },
              ],
            },
          },
        },
        launchingGameController: {
          initial: 'idle',
          invoke: [{ src: 'watchGameActions' }],
          states: {
            idle: {
              always: [
                {
                  target: 'initGameLauncherCommunication',
                },
              ],
            },
            initGameLauncherCommunication: {
              invoke: {
                src: 'initializeGameFrameBridge',
                onDone: {
                  target: 'initGameLaunchObserver',
                },
              },
            },
            initGameLaunchObserver: {
              on: {
                LAYOUT_CHANGE_END: {
                  target: 'transient',
                  cond: 'isControllerEnabled_gameLauncher',
                },
                PROMOTIONS_GAME_OPEN_CLICK: {
                  target: 'fetchGameLaunch',
                },
                VIEW_CATEGORY_GAME_TILE_CLICK: [
                  {
                    target: 'transient',
                    actions: 'trackGameClick',
                  },
                ],
                VIEW_BOTTOM_MENU_GAME_CLICK: {
                  target: 'transient',
                  actions: 'trackGameClick',
                },
                VIEW_SIDE_MENU_GAME_CLICK: {
                  target: 'transient',
                  actions: ['trackGameClick'],
                },
                VIEW_GAME_DETAILS_BUTTON_CLICK: [
                  {
                    target: 'transient',
                    actions: 'trackGameClick',
                  },
                ],
                TREBUCHET_PARTIAL_EVENT_CALLED: {
                  actions: 'trackTrebuchetPartialEvent',
                },
                VIEW_SUGGESTED_GAMES_TILE_CLICK: [
                  {
                    target: 'fetchGameLaunch',
                    actions: [
                      'setSuggestedGameUrl',
                      'trackSuggestedGameClick',
                      'removeLastPagePath',
                    ],
                  },
                ],
              },
            },
            transient: {
              always: [
                {
                  target: 'waitingForSession',
                  cond: 'isSessionNotResolved',
                },
                { target: 'setGameToLaunch' },
              ],
            },
            waitingForSession: {
              on: {
                SESSION_STATE_LOGGED_OUT: 'setGameToLaunch',
                SESSION_STATE_LOGGED_IN: 'setGameToLaunch',
              },
            },
            fetchGameLaunch: {
              invoke: {
                src: 'fetchGameToLaunch',
                onDone: [
                  {
                    cond: 'isGameFetched',
                    target: 'setGameToLaunch',
                  },
                  {
                    target: 'initGameLaunchObserver',
                    actions: ['gameFetchFailed'],
                  },
                ],
                onError: {
                  target: 'initGameLaunchObserver',
                  actions: ['layout_openSystemErrorPage'],
                },
              },
            },
            setGameToLaunch: {
              invoke: {
                src: 'setGameToLaunchData',
                onDone: {
                  target: 'initLaunchGameFlow',
                  actions: {
                    type: 'save',
                    data: {
                      gameToLaunch: '$event.data.gameToLaunch',
                    },
                    meta: {
                      selectors: ['$action.data.gameToLaunch'],
                    },
                  },
                },
              },
            },
            initLaunchGameFlow: {
              always: [
                {
                  target: 'launchingGameWithLogin',
                  cond: 'isNotAllowedToLaunchGame',
                },
                {
                  target: 'launchGameInModal',
                  cond: 'isLargeScreenWithHeader',
                },
                {
                  target: 'launchGame',
                  cond: 'isGameTriggeredByUserInteraction',
                },
                {
                  target: 'openGameDetailsPage',
                  actions: 'removeGameLaunchController',
                },
              ],
            },
            launchingGameWithLogin: {
              invoke: {
                src: 'launchLogin',
              },
              on: {
                SESSION_STATE_LOGGED_IN: [
                  {
                    target: 'launchGameInModal',
                    cond: 'isLargeScreenWithHeader',
                  },
                  {
                    target: 'initGameLaunchObserver',
                    cond: 'isGameDetailsPage',
                  },
                  {
                    target: 'openGameDetailsPage',
                  },
                ],
                LOGIN_MODAL_STATE_CLOSED: [
                  {
                    target: 'initGameLaunchObserver',
                    cond: 'isNotAwaitingLogin',
                  },
                ],
              },
            },
            openGameDetailsPage: {
              always: [
                {
                  actions: ['removeLastPagePath', 'gameDetails_open'],
                  target: 'initGameLaunchObserver',
                  cond: 'isOnLaunchPathAlready',
                },
                {
                  actions: ['gameDetails_open'],
                  target: 'initGameLaunchObserver',
                },
              ],
            },
            launchGameInModal: {
              entry: [
                'hideBalance',
                {
                  type: 'setLayoutProperty',
                  data: {
                    path: 'components.GameModal.properties.game',
                    value: '$context.gameToLaunch',
                  },
                  meta: {
                    selectors: ['$action.data.value'],
                  },
                },
                {
                  type: 'setLayoutProperty',
                  data: {
                    path: 'components.Modal.properties.componentVisible',
                    value: false,
                  },
                  meta: {
                    selectors: ['$action.data.value'],
                  },
                },
                'gameModal_open',
                'fetchRecentlyPlayedAfterDelay',
              ],
              always: 'initGameLaunchObserver',
            },
            launchGame: {
              always: {
                target: 'initGameLaunchObserver',
                actions: [
                  'fetchRecentlyPlayedAfterDelay',
                  {
                    type: 'save',
                    data: {
                      gameToLaunch: null,
                    },
                  },
                ],
              },
            },
          },
        },
        header: {
          invoke: {
            src: 'watchHeaderActions',
          },
          initial: 'idle',
          states: {
            idle: {
              on: {
                WH_HEADER_INITIALIZED: {
                  actions: 'setHeaderInitialized',
                },
                VIEW_PARTIAL_EVENT_CALLED: {
                  actions: 'trackPartialEvent',
                },
                VIEW_FEEDBACK_EVENT_CALLED: {
                  actions: 'openUsabilla',
                },
                VIEW_HELP_EVENT_CALLED: {
                  actions: 'openAccountHelp',
                },
                GAMING_USER_DETAILS_FETCHED: {
                  actions: [
                    'updateUserTrackingInfo',
                    'saveInfoAccountInfo',
                    'trackPendingAccountEvents',
                  ],
                },
                VIEW_HAMBURGER_MENU_CLICK: {
                  actions: ['trackHamburgerClick', 'nav_HANDLE_CHANGE'],
                },
              },
            },
          },
        },
        headerProductNavigation: {
          initial: 'idle',
          states: {
            idle: {
              always: [
                {
                  target: 'on',
                  cond: 'isKrakenEnabled',
                },
                {
                  target: 'off',
                },
              ],
            },
            on: {
              invoke: {
                src: 'watchHeaderProductNavigationActions',
              },
              on: {
                VIEW_HEADER_PRODUCT_EVENT_CALLED: {
                  actions: [
                    'trackRedirectToProduct',
                    'initiateRedirectWithDelay',
                  ],
                },
                REDIRECT_TO_PRODUCT: {
                  actions: 'redirectToProductPage',
                },
              },
            },
            off: {},
          },
        },
        account: {
          initial: 'idle',
          states: {
            idle: {
              always: [
                {
                  target: 'on',
                  cond: 'isKrakenEnabled',
                },
                {
                  target: 'off',
                },
              ],
            },
            on: {
              invoke: {
                src: 'watchAccountActions',
              },
              on: {
                VIEW_PROMOTIONS_EVENT_CALLED: {
                  actions: 'openPromotionsPage',
                },
                APP_VISIBILITY_VISIBLE: {
                  actions: 'updateBalance',
                },
              },
            },
            off: {},
          },
        },
        cookieBanner: {
          initial: 'idle',
          states: {
            idle: {
              always: [
                {
                  target: 'on',
                  cond: 'isCookieBannerEnabled',
                },
                {
                  target: 'off',
                },
              ],
            },
            on: {
              invoke: {
                src: 'fetchCookieBannerInfo',
                onDone: [
                  {
                    target: 'visible',
                    cond: 'isCookieVisible',
                  },
                  {
                    actions: [
                      {
                        type: 'sendTrackEvents',
                      },
                      {
                        type: 'save',
                        data: { delayedTrackingAvailable: true },
                      },
                    ],
                    target: 'hidden',
                  },
                ],
              },
            },
            visible: {
              entry: {
                type: 'showLayoutComponent',
                data: 'CookieBanner',
              },
              on: {
                VIEW_COOKIE_BANNER_CLICK: {
                  target: 'accepted',
                },
                LAYOUT_CHANGE_END: {
                  target: 'visible',
                },
              },
            },
            hidden: {
              entry: [
                {
                  type: 'hideLayoutComponent',
                  data: 'CookieBanner',
                },
              ],
            },
            accepted: {
              entry: [
                {
                  type: 'setCookieBannerCookie',
                },
                {
                  type: 'sendTrackEvents',
                },
                {
                  type: 'save',
                  data: { delayedTrackingAvailable: true },
                },
                {
                  type: 'hideLayoutComponent',
                  data: 'CookieBanner',
                },
              ],
            },
            off: {},
          },
        },
        initializing: {
          initial: 'init',
          states: {
            init: {
              initial: 'initialisingConfig',
              states: {
                initialisingConfig: {
                  entry: 'handleOpenInIframe',
                  invoke: {
                    src: 'initialiseConfig',
                    onDone: {
                      target: 'initialisingFeatureFlags',
                    },
                    onError: {
                      target: 'initialisingFeatureFlags',
                    },
                  },
                },
                initialisingFeatureFlags: {
                  invoke: {
                    src: 'fetchFeatureFlagsConfig',
                    onDone: {
                      target: 'checkSegmentsCookie',
                      actions: [
                        {
                          type: 'save',
                          data: {
                            features: '$event.data',
                          },
                          meta: {
                            selectors: ['$action.data.features'],
                          },
                        },
                      ],
                    },
                  },
                },
                checkSegmentsCookie: {
                  invoke: {
                    src: 'fetchSegmentsCookie',
                    onDone: [
                      {
                        target: 'installingTracking',
                        actions: ['checkSegmentsCookie'],
                      },
                    ],
                  },
                },
                installingTracking: {
                  invoke: {
                    entry: ['installTracking'],
                    src: 'initializeTrackingData',
                    onDone: [
                      {
                        target: 'trackGamingRollout',
                        actions: 'saveInitialTrackingData',
                        cond: 'isRoutingEnabled',
                      },
                      {
                        target: 'fetchDeviceInfo',
                        actions: 'saveInitialTrackingData',
                      },
                    ],
                  },
                },
                trackGamingRollout: {
                  invoke: {
                    src: 'trackGamingRollout',
                    onDone: [
                      {
                        target: 'fetchDeviceInfo',
                      },
                    ],
                  },
                },
                fetchDeviceInfo: {
                  invoke: {
                    src: 'fetchDeviceInfo',
                    onDone: [
                      {
                        target: 'fetchInitialPage',
                        actions: [
                          'manageGameLaunchCallbackMode',
                          {
                            type: 'save',
                            data: {
                              currentScreenSize:
                                '$event.data.currentScreenSize',
                              deviceInfo: '$event.data.deviceInfo',
                            },
                            meta: {
                              selectors: [
                                '$action.data.deviceInfo',
                                '$action.data.currentScreenSize',
                              ],
                            },
                          },
                        ],
                      },
                    ],
                  },
                },
                fetchInitialPage: {
                  invoke: {
                    src: 'fetchPageInfo',
                    onDone: [
                      {
                        target: 'displayPagePreloaded',
                        cond: 'isLayoutPreloadedAndNormalPage',
                        actions: [
                          'updateCurrentPagePath',
                          {
                            type: 'save',
                            data: {
                              navigationLinks: '$event.data.navigationLinks',
                              isSidebarInLayout:
                                '$event.data.isSidebarInLayout',
                              currentLayout: '$event.data.currentLayout',
                              mainLayoutPath: '$event.data.mainLayoutPath',
                              controllersData: '$event.data.controllersData',
                              initialRequest: '$event.data.initialRequest',
                              currentTablesIdList:
                                '$event.data.liveDealerTables',
                              personalizedBanners:
                                '$event.data.personalizedBanners',
                              currentPagePath: '$event.data.currentPagePath',
                              trackingData: '$event.data.trackingInfo',
                              seo: '$event.data.seo',
                              isErrorPage: '$event.data.isErrorPage',
                              changePageAction: '',
                            },
                            meta: {
                              selectors: [
                                '$action.data.navigationLinks',
                                '$action.data.isSidebarInLayout',
                                '$action.data.currentLayout',
                                '$action.data.mainLayoutPath',
                                '$action.data.controllersData',
                                '$action.data.initialRequest',
                                '$action.data.currentTablesIdList',
                                '$action.data.personalizedBanners',
                                '$action.data.currentPagePath',
                                '$action.data.trackingData',
                                '$action.data.seo',
                                '$action.data.isErrorPage',
                              ],
                            },
                          },
                          {
                            type: 'setLayoutProperty',
                            data: {
                              path:
                                'components.ContentWrapper.properties.isSidebarInLayout',
                              value: '$context.isSidebarInLayout',
                            },
                            meta: {
                              selectors: ['$action.data.value'],
                            },
                          },
                          {
                            type: 'setLayoutProperty',
                            data: {
                              path: 'components.Layout.properties.deviceType',
                              value: '$context.deviceInfo.deviceType',
                            },
                            meta: {
                              selectors: ['$action.data.value'],
                            },
                          },
                          {
                            type: 'setLayoutProperty',
                            data: {
                              path: 'components.Layout.properties.deviceOs',
                              value: '$context.deviceInfo.deviceOs',
                            },
                            meta: {
                              selectors: ['$action.data.value'],
                            },
                          },
                          {
                            type: 'setLayoutProperty',
                            data: {
                              path:
                                'components.Modal.properties.componentVisible',
                              value: '$context.isSidebarInLayout',
                            },
                            meta: {
                              selectors: ['$action.data.value'],
                            },
                          },
                          {
                            type: 'setLayoutProperty',
                            data: {
                              path:
                                'components.BottomNavigation.properties.callbackMode',
                              value: '$context.callbackMode',
                            },
                            meta: {
                              selectors: ['$action.data.value'],
                            },
                          },
                          {
                            type: 'setLayoutProperty',
                            data: {
                              path:
                                'components.StaticNavigation.properties.callbackMode',
                              value: '$context.callbackMode',
                            },
                            meta: {
                              selectors: ['$action.data.value'],
                            },
                          },
                          'updateSiteTrackingStorageInfo',
                          'trackPageChange',
                          'updateSeo',
                          'saveSegments',
                        ],
                      },
                      {
                        target: 'displayPagePreloaded',
                        cond: 'isLayoutPreloadedAndErrorPage',
                        actions: [
                          'updateCurrentPagePath',
                          {
                            type: 'save',
                            data: {
                              isErrorPage: '$event.data.isErrorPage',
                              initialRequest: '$event.data.initialRequest',
                            },
                            meta: {
                              selectors: [
                                '$action.data.isErrorPage',
                                '$action.data.initialRequest',
                              ],
                            },
                          },
                        ],
                      },
                      {
                        target: 'displayPage',
                        actions: [
                          'updateCurrentPagePath',
                          'updateSiteTrackingStorageInfo',
                          {
                            type: 'save',
                            data: {
                              initialRequest: '$event.data.initialRequest',
                            },
                            meta: {
                              selectors: ['$action.data.initialRequest'],
                            },
                          },
                        ],
                      },
                    ],
                  },
                },
                displayPage: {
                  entry: [
                    {
                      type: 'save',
                      data: {
                        appInitialized: true,
                      },
                    },
                    'layout_changePageId',
                  ],
                },
                displayPagePreloaded: {
                  entry: [
                    {
                      type: 'save',
                      data: {
                        appInitialized: true,
                      },
                    },
                    {
                      cond: 'isModalVisibleOnBigScreen',
                      type: ['scrollTop', 'setBodyNonScrollable'],
                    },
                    'layout_notifyChangeEnd',
                  ],
                },
              },
            },
          },
        },
        screenSizeManager: {
          initial: 'idle',
          invoke: {
            src: 'watchScreenMode',
          },
          states: {
            idle: {
              on: {
                ENVIRONMENT_SCREEN_SIZE_CHANGED: [
                  {
                    actions: [
                      'saveCurrentScreenSize',
                      'manageGameLaunchCallbackMode',
                      'setBodyScrollable',
                      'scrollTop',
                    ],
                  },
                ],
              },
            },
          },
        },
        globalListeners: {
          initial: 'idle',
          invoke: {
            src: 'watchRouteChange',
          },
          states: {
            idle: {
              on: {
                UPDATE_PAGE: {
                  target: 'waitForRouteChange',
                  actions: [
                    'updatePrevPageArray',
                    'updateCurrentPagePath',
                    'updateUrl',
                    'layout_changePageId',
                  ],
                },
                VIEW_HEADER_MENU_ITEM_CLICK: {
                  target: 'handlingNavigationItem',
                  actions: [
                    'handleSubnavigationScrollReset',
                    'trackMenuItemClick',
                  ],
                },
                VIEW_SIDE_MENU_ITEM_CLICK: [
                  {
                    target: 'handlingNavigationItem',
                    cond: 'isClickedItemInternal',
                    actions: 'trackSideItemClick',
                  },
                  {
                    actions: 'trackSideItemClick',
                  },
                ],
                VIEW_SIDE_MENU_GAME_INFO_CLICK: {
                  actions: [
                    {
                      type: 'save',
                      data: {
                        changePageAction: 'INFO',
                      },
                    },
                    'trackSideItemClick',
                  ],
                  target: 'handlingGameDetails',
                },
                VIEW_SIDE_MENU_COMMAND_CLICK: [
                  {
                    target: 'openingAccountItemModal',
                    cond: 'isClickedItemAccount',
                    actions: 'trackMainMenuItemClick',
                  },
                  {
                    actions: 'trackMainMenuItemClick',
                  },
                ],
                VIEW_CATEGORY_VIEW_ALL_CLICK: {
                  actions: [
                    {
                      type: 'save',
                      data: {
                        changePageAction: 'VIEW_ALL',
                      },
                    },
                  ],
                  target: 'handlingNavigationItem',
                },
                VIEW_CATEGORY_ROUTE_ITEM_CLICK: {
                  target: 'handlingNavigationItem',
                  actions: 'trackPromoClick',
                },
                VIEW_CATEGORY_LINK_ITEM_CLICK: {
                  actions: 'trackPromoClick',
                },
                VIEW_BOTTOM_MENU_ITEM_CLICK: [
                  {
                    target: 'handlingNavigationItem',
                    cond: 'isClickedItemInternal',
                    actions: 'trackBottomNavigationClick',
                  },
                  {
                    actions: 'trackBottomNavigationClick',
                  },
                ],
                VIEW_BOTTOM_MENU_COMMAND_CLICK: [
                  {
                    target: 'handlingNavigationCommand',
                    cond: 'isClickedLeftSliderCommand',
                    actions: 'trackBottomNavigationClick',
                  },
                  {
                    actions: 'trackBottomNavigationClick',
                  },
                ],
                VIEW_ERROR_ITEM_CLICK: [
                  {
                    target: 'handlingErrorItem',
                    actions: [
                      {
                        type: 'save',
                        data: { isErrorPage: false, initialRequest: true },
                      },
                      'trackErrorItemClick',
                    ],
                    cond: 'isClickedItemInternal',
                  },
                  {
                    actions: [
                      { type: 'save', data: { initialRequest: true } },
                      'trackErrorItemClick',
                    ],
                  },
                ],
                VIEW_MAIN_MENU_ITEM_CLICK: [
                  {
                    target: 'handlingNavigationItem',
                    actions: 'trackMainMenuItemClick',
                    cond: 'isClickedItemInternal',
                  },
                  {
                    target: 'openingAccountItemModal',
                    cond: 'isClickedItemAccount',
                    actions: 'trackMainMenuItemClick',
                  },
                  {
                    actions: 'trackMainMenuItemClick',
                  },
                ],
                VIEW_MAIN_MENU_CLOSE_CLICK: 'closeMainMenu',
                VIEW_HEADER_BACK_BUTTON_CLICK: 'handlingBackButtonClick',
                VIEW_BREADCRUMB_CLICK: 'handlingNavigationItem',
                VIEW_CATEGORY_GAME_TILE_INFO_CLICK: {
                  actions: [
                    {
                      type: 'save',
                      data: {
                        changePageAction: 'INFO',
                      },
                    },
                  ],
                  target: 'handlingGameDetails',
                },
                OPEN_GAME_DETAILS: 'handlingGameDetails',
                VIEW_SEARCH_WRAPPER_CLICK: 'handlingNavigationItem',
                OPEN_GAME_MODAL: {
                  target: 'waitForRouteChange',
                  actions: [
                    'updatePrevPageArray',
                    'updateCurrentPagePath',
                    'updateUrl',
                    'saveScrollPosition',
                    'setBodyNonScrollable',
                    'layout_openGameModal',
                  ],
                },
                VIEW_CLOSE_GAME_MODAL_TRIGGER: 'chooseGameModalCloseMethod',
                VIEW_CLOSE_GAME_MODAL_THROUGH_GAME_FRAME:
                  'closeGameModalThroughGameFrame',
                VIEW_CLOSE_GAME_MODAL: 'closeGameModal',
                VIEW_OPEN_DEPOSIT_GAME_MODAL: 'openDeposit',
                VIEW_MODAL_OVERLAY_CLICK: 'closeSidebar',
                UPDATE_PROMOTIONS_URL: 'updatePromotionsUrl',
                SESSION_STATE_LOGGED_OUT: {
                  target: 'goingBackToPreviousPage',
                  cond: 'currentlyOnRecentlyPlayedPage',
                },
                NAV_HANDLE_CHANGE: [
                  {
                    target: 'handlingNavigationCommand',
                    cond: 'isClickedLeftSliderCommand',
                  },
                  {
                    target: 'handlingNavigationItem',
                  },
                ],
                ROUTE_CHANGED: 'reactOnRouteChange',
                GLOBAL_GOBACK: 'goingBackToPreviousPage',
              },
            },
            openingAccountItemModal: {
              invoke: {
                src: 'fetchAccountItemModal',
                onDone: {
                  target: 'idle',
                },
              },
            },
            waitForRouteChange: {
              on: {
                LAYOUT_CHANGE_END: {
                  target: 'idle',
                  cond: 'isRoutingNotEnabled',
                },
                VIEW_CLOSE_GAME_MODAL: 'closeGameModal',
                LAYOUT_MODAL_CLOSE: {
                  target: 'idle',
                  cond: 'isRoutingNotEnabled',
                },
                ROUTE_CHANGED: 'idle',
              },
            },
            updatePromotionsUrl: {
              entry: 'updatePromotionsPath',
              always: 'waitForRouteChange',
            },
            closeSidebar: {
              invoke: {
                src: 'fetchPreviousPageInfo',
                data: {
                  sidebar: true,
                },
                onDone: {
                  target: 'waitForRouteChange',
                  actions: [
                    {
                      type: 'save',
                      data: {
                        previousPageArray: '$event.data.previousPageArray',
                        trackingData: {
                          page: '$context.trackingData.page',
                          sidebar: null,
                        },
                        seo: {
                          page: '$context.seo.page',
                          sidebar: null,
                        },
                      },
                      meta: {
                        selectors: [
                          '$action.data.previousPageArray',
                          '$action.data.trackingData.page',
                          '$action.data.seo.page',
                        ],
                      },
                    },
                    'updateUrl',
                    'updateCurrentPagePath',
                    'layout_closeSidebar',
                    'setBodyScrollable',
                  ],
                },
              },
            },
            openDeposit: {
              entry: 'openDeposit',
              always: 'idle',
            },
            chooseGameModalCloseMethod: {
              entry: 'chooseGameModalCloseMethod',
              always: 'idle',
            },
            closeGameModalThroughGameFrame: {
              entry: 'sendGameModalCloseToGameFrame',
              always: 'idle',
            },
            closeGameModal: {
              entry: [
                'setBodyScrollable',
                'layout_closeGameModal',
                'removeGameLaunchController',
                'showBalance',
                'updateBalance',
              ],
              always: 'goingBackToPreviousPage',
            },
            closeMainMenu: {
              entry: [
                {
                  type: 'setLayoutProperty',
                  data: {
                    path: 'components.LeftSlider.properties.componentVisible',
                    value: false,
                  },
                },
                {
                  type: 'setLayoutProperty',
                  data: {
                    path: 'components.Menu.properties.componentVisible',
                    value: false,
                  },
                },
                {
                  type: 'setLayoutProperty',
                  data: {
                    path:
                      'components.BottomNavigation.properties.activeCommandItem',
                    value: false,
                  },
                },
              ],
              always: 'idle',
            },
            reactOnRouteChange: {
              invoke: {
                src: 'fetchPageInfo',
                onDone: [
                  {
                    target: 'idle',
                    actions: [
                      {
                        type: 'setLayoutProperty',
                        data: {
                          path: 'components.GameModal.properties.visible',
                          value: false,
                        },
                      },
                      'setBodyScrollable',
                      'updateCurrentPagePath',
                      'showBalance',
                      'layout_changePageId',
                    ],
                  },
                ],
              },
            },
            handlingGameDetails: {
              entry: [
                'resetPageAction',
                'updatePrevPageArray',
                'updateCurrentPagePath',
                'updateUrl',
                'layout_changePageId',
              ],
              always: 'waitForRouteChange',
            },
            handlingErrorItem: {
              entry: [
                'updatePrevPageArray',
                'updateCurrentPagePath',
                'resetPageAction',
                'updateUrl',
                'layout_changePageId',
              ],
              always: 'waitForRouteChange',
            },
            handlingNavigationItem: {
              entry: [
                'updatePrevPageArray',
                'updateCurrentPagePath',
                'resetPageAction',
                'saveScrollPosition',
                'updateUrl',
                'layout_changePageId',
                {
                  type: 'setLayoutProperty',
                  data: {
                    path: 'components.Menu.properties.componentVisible',
                    value: false,
                  },
                },
                {
                  type: 'setLayoutProperty',
                  data: {
                    path: 'components.Navigation.properties.initialScrollValue',
                    value: '$context.subnavigationScrollPosition',
                  },
                  meta: {
                    selectors: ['$action.data.value'],
                  },
                },
                {
                  type: 'setLayoutProperty',
                  data: {
                    path:
                      'components.BottomNavigation.properties.activeCommandItem',
                    value: false,
                  },
                },
              ],
              always: 'waitForRouteChange',
            },
            handlingNavigationCommand: {
              entry: [
                {
                  type: 'setLayoutProperty',
                  data: {
                    path: 'components.LeftSlider.properties.componentVisible',
                    value: true,
                  },
                },
                {
                  type: 'setLayoutProperty',
                  data: {
                    path: 'components.Menu.properties.componentVisible',
                    value: true,
                  },
                },
                {
                  type: 'setLayoutProperty',
                  data: {
                    path:
                      'components.BottomNavigation.properties.activeCommandItem',
                    value: true,
                  },
                },
              ],
              always: 'idle',
            },
            handlingBackButtonClick: {
              always: [
                {
                  target: 'closingApp',
                  cond: 'currentlyOnNavigationItemPage',
                },
                {
                  target: 'goingBackToPreviousPage',
                },
              ],
            },
            goingBackToPreviousPage: {
              invoke: {
                src: 'fetchPreviousPageInfo',
                onDone: {
                  actions: [
                    {
                      type: 'save',
                      data: {
                        changePageAction: 'BACK',
                        previousPageArray: '$event.data.previousPageArray',
                      },
                      meta: {
                        selectors: ['$action.data.previousPageArray'],
                      },
                    },
                    'setBodyScrollable',
                    'updateCurrentPagePath',
                    'resetPageAction',
                    'updateUrl',
                    'layout_changePageId',
                  ],
                  target: 'waitForRouteChange',
                },
              },
            },
            closingApp: {
              entry: ['scrollTop', 'closeApplication'],
              always: 'idle',
            },
          },
        },
        trackingListener: {
          initial: 'idle',
          states: {
            idle: {
              on: {
                TRACK_PAGE_CHANGE: 'transient',
                ENVIROMENT_USER_ACTION_TRIGGERED: {
                  cond: 'delayedTrackingNotInstalled',
                  actions: [
                    {
                      type: 'sendTrackEvents',
                    },
                  ],
                },
              },
            },
            transient: {
              always: [
                {
                  target: 'waitingForSession',
                  cond: 'isSessionNotResolved',
                },
                { target: 'tracking' },
              ],
            },
            waitingForSession: {
              on: {
                SESSION_STATE_LOGGED_OUT: 'tracking',
                SESSION_STATE_LOGGED_IN: 'tracking',
              },
            },
            tracking: {
              entry: 'trackPageChange',
              always: 'idle',
            },
          },
        },
        headerManager: {
          initial: 'idle',
          states: {
            idle: {
              on: {
                LAYOUT_CHANGE_END: 'updateHeaderProperties',
              },
            },
            updateHeaderProperties: {
              invoke: {
                src: 'setHeaderProperties',
                onDone: {
                  target: 'idle',
                  actions: {
                    type: 'batchLayoutOperations',
                    data: '$event.data.updates',
                    meta: {
                      selectors: ['$action.data'],
                    },
                  },
                },
              },
            },
          },
        },
        navManager: {
          initial: 'idle',
          states: {
            idle: {
              on: {
                LAYOUT_PAGEID_CHANGE: 'updateNavComponents',
                LAYOUT_CHANGE_END: 'updateNavComponents',
                LAYOUT_MODAL_CLOSE: 'updateNavComponents',
              },
            },
            updateNavComponents: {
              always: {
                target: 'idle',
                actions: [
                  {
                    type: 'batchLayoutOperations',
                    data: [
                      {
                        type: 'setLayoutProperty',
                        data: {
                          path:
                            'components.BottomNavigation.properties.currentPagePath',
                          value: '$event.mainLayoutPath',
                        },
                        meta: {
                          selectors: ['$action.data.value'],
                        },
                      },
                      {
                        type: 'setLayoutProperty',
                        data: {
                          path:
                            'components.StaticNavigation.properties.currentPagePath',
                          value: '$event.mainLayoutPath',
                        },
                        meta: {
                          selectors: ['$action.data.value'],
                        },
                      },
                    ],
                  },
                ],
              },
            },
          },
        },
        layoutManager: {
          initial: 'idle',
          states: {
            idle: {
              on: {
                LAYOUT_SYSTEM_ERROR_PAGE_OPEN: 'openErrorPage',
                LAYOUT_PAGEID_CHANGE: 'switchingLayout',
                LAYOUT_RELOAD: 'scrollPositioning',
                LAYOUT_MODAL_CLOSE: 'closeSidebar',
                LAYOUT_GAME_MODAL_OPEN: 'openGameModal',
                LAYOUT_GAME_MODAL_CLOSE: 'closeGameModal',
              },
            },
            switchingLayout: {
              invoke: {
                src: 'pageIdToLayoutChange',
                onDone: {
                  target: 'scrollPositioning',
                  actions: [
                    {
                      type: 'save',
                      data: {
                        navigationLinks: '$event.data.navigationLinks',
                        isSidebarInLayout: '$event.data.isSidebarInLayout',
                        currentLayout: '$event.data.currentLayout',
                        pageTitle: '$event.data.pageTitle',
                        mainLayoutPath: '$event.data.mainLayoutPath',
                        controllersData: '$event.data.controllersData',
                        currentTablesIdList: '$event.data.currentTablesIdList',
                        trackingData: '$event.data.trackingData',
                        seo: '$event.data.seo',
                        initialRequest: false,
                        segments: '$event.data.segments',
                        personalizedBanners: '$event.data.personalizedBanners',
                        gameLaunchStrategies:
                          '$event.data.gameLaunchStrategies',
                        isErrorPage: '$event.data.isErrorPage',
                        changePageAction: '',
                      },
                      meta: {
                        selectors: [
                          '$action.data.navigationLinks',
                          '$action.data.isSidebarInLayout',
                          '$action.data.currentLayout',
                          '$action.data.pageTitle',
                          '$action.data.mainLayoutPath',
                          '$action.data.controllersData',
                          '$action.data.currentTablesIdList',
                          '$action.data.trackingData',
                          '$action.data.seo',
                          '$action.data.segments',
                          '$action.data.personalizedBanners',
                          '$action.data.gameLaunchStrategies',
                          '$action.data.isErrorPage',
                        ],
                      },
                    },
                    {
                      type: 'batchLayoutOperations',
                      data: '$event.data.updates',
                      meta: {
                        selectors: ['$action.data'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path:
                          'components.ContentWrapper.properties.isSidebarInLayout',
                        value: '$context.isSidebarInLayout',
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.Layout.properties.deviceType',
                        value: '$context.deviceInfo.deviceType',
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.Layout.properties.deviceOs',
                        value: '$context.deviceInfo.deviceOs',
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.Modal.properties.componentVisible',
                        value: '$context.isSidebarInLayout',
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path:
                          'components.BottomNavigation.properties.callbackMode',
                        value: '$context.callbackMode',
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path:
                          'components.StaticNavigation.properties.callbackMode',
                        value: '$context.callbackMode',
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    'updateSiteTrackingStorageInfo',
                    'trackPageChange',
                    'updateSeo',
                    'saveSegments',
                  ],
                },
              },
              exit: 'layout_notifyChangeEnd',
            },
            scrollPositioning: {
              always: [
                {
                  actions: ['restoreScrollPosition', 'clearScrollRestore'],
                  target: 'idle',
                  cond: 'requiresScrollRestore',
                },
                {
                  target: 'idle',
                  cond: 'isModalVisibleOnBigScreen',
                  actions: 'setBodyNonScrollable',
                },
                {
                  actions: ['scrollTop'],
                  target: 'idle',
                },
              ],
            },
            closeSidebar: {
              entry: [
                {
                  type: 'setLayoutProperty',
                  data: {
                    path: 'components.Modal.properties',
                    value: {
                      componentVisible: false,
                      backButtonVisible: false,
                    },
                  },
                },
                {
                  type: 'setLayoutProperty',
                  data: {
                    path: 'components.copy.properties',
                    value: {
                      visible: true,
                    },
                  },
                },
                {
                  type: 'save',
                  data: {
                    isSidebarInLayout: false,
                  },
                },
                'updateSiteTrackingStorageInfo',
                'tracking_changePage',
                'updateSeo',
              ],
              always: 'idle',
            },
            openGameModal: {
              entry: [
                {
                  type: 'batchLayoutOperations',
                  data: [
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.Modal.properties.componentVisible',
                        value: false,
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.GameModal.properties.visible',
                        value: true,
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                  ],
                },
                'updateGameLaunchedTracking',
              ],
              always: 'idle',
            },
            closeGameModal: {
              entry: [
                {
                  type: 'save',
                  data: {
                    changePageAction: 'BACK',
                  },
                },
                {
                  type: 'batchLayoutOperations',
                  data: [
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.GameModal.properties.visible',
                        value: false,
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.GameModal.properties.game',
                        value: {},
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                  ],
                },
                'resetGameLaunchedTracking',
              ],
              always: 'idle',
            },
            openErrorPage: {
              invoke: {
                src: 'getErrorPage',
                onDone: {
                  target: 'idle',
                  actions: [
                    {
                      type: 'batchLayoutOperations',
                      data: '$event.data.updates',
                      meta: {
                        selectors: ['$action.data'],
                      },
                    },
                  ],
                },
              },
            },
          },
        },
        personalizedBannerManager: {
          initial: 'off',
          states: {
            off: {
              on: {
                LAYOUT_CHANGE_END: {
                  target: 'on',
                  cond: 'isPersonalizedBannerInKraken',
                },
              },
            },
            on: {
              type: 'parallel',
              states: {
                fetchingPersonalizedBanners: {
                  initial: 'initializingBanners',
                  states: {
                    initializingBanners: {
                      invoke: {
                        src: 'initializePersonalizedBanners',
                        onDone: {
                          target: 'watchPersonalizedBanners',
                        },
                      },
                    },
                    watchPersonalizedBanners: {
                      invoke: {
                        src: 'watchPersonalizedBanners',
                      },
                      on: {
                        PERSONALIZED_BANNERS_UPDATED: {
                          actions: [
                            'updatePersonalizedBanners',
                            'categories_reload',
                          ],
                        },
                      },
                    },
                  },
                  onDone: 'idle',
                },
                idle: {
                  on: {
                    REFETCH_PERSONALIZED_BANNERS: 'fetchingPersonalizedBanners',
                    LAYOUT_CHANGE_END: {
                      target: 'fetchingPersonalizedBanners',
                      cond: 'isPersonalizedBannerInKraken',
                    },
                  },
                },
              },
              on: {
                LAYOUT_CHANGE_END: {
                  target: 'off',
                  cond: 'isNotPersonalizedBannerInKraken',
                },
              },
            },
          },
        },
        categoriesController: {
          initial: 'off',
          states: {
            off: {
              on: {
                LAYOUT_CHANGE_END: {
                  target: 'on',
                  cond: 'isControllerEnabled_categories',
                },
              },
            },
            on: {
              type: 'parallel',
              states: {
                layoutReloader: {
                  initial: 'reloading',
                  states: {
                    idle: {
                      on: {
                        RELOAD_CATEGORIES: 'reloading',
                      },
                    },
                    reloading: {
                      invoke: {
                        src: 'getCategoriesLayoutContent',
                        onDone: {
                          target: 'idle',
                          actions: [
                            {
                              type: 'batchLayoutOperations',
                              data: '$event.data.updates',
                              meta: {
                                selectors: ['$action.data'],
                              },
                            },
                          ],
                        },
                      },
                      on: {
                        RELOAD_CATEGORIES: 'reloading',
                      },
                    },
                  },
                },
                view_loaded: {
                  type: 'parallel',
                  states: {
                    fetchingData: {
                      initial: 'fetchingJackpots',
                      states: {
                        fetchingJackpots: {
                          invoke: {
                            src: 'fetchJackpots',
                            onDone: {
                              actions: ['updateJackpots', 'categories_reload'],
                              target: 'fetchingTables',
                            },
                          },
                        },
                        fetchingTables: {
                          invoke: {
                            src: 'fetchTableForPageGames',
                            onDone: {
                              actions: ['updateTables', 'categories_reload'],
                              target: 'done',
                            },
                          },
                        },
                        done: {
                          invoke: [
                            { src: 'watchJackpots' },
                            { src: 'watchLiveTableGames' },
                          ],
                          on: {
                            JACKPOTS_UPDATED: {
                              actions: ['updateJackpots', 'categories_reload'],
                            },
                            LIVE_TABLE_GAMES_UPDATED: {
                              actions: ['updateTables', 'categories_reload'],
                            },
                          },
                        },
                      },
                    },
                    idle: {
                      on: {
                        REFETCH_CATEGORIES: 'fetchingData',
                      },
                    },
                  },
                  onDone: 'idle',
                },
                idle: {
                  on: {
                    LAYOUT_CHANGE_END: {
                      cond: 'isControllerEnabled_categories',
                      actions: ['categories_refetch', 'categories_reload'],
                    },
                  },
                },
              },
              on: {
                LAYOUT_CHANGE_END: {
                  target: 'off',
                  cond: 'isControllerDisabled_categories',
                },
              },
            },
          },
        },
        recentlyPlayedController: {
          initial: 'off',
          states: {
            off: {
              on: {
                LAYOUT_CHANGE_END: {
                  target: 'on',
                  cond: 'isControllerEnabled_recentlyPlayed',
                },
              },
            },
            on: {
              initial: 'updatingRP',
              states: {
                idle: {
                  on: {
                    RP_RERENDER: 'updatingRP',
                    LAYOUT_CHANGE_END: {
                      cond: 'isControllerEnabled_recentlyPlayed',
                      target: 'updatingRP',
                    },
                  },
                },
                updatingRP: {
                  invoke: {
                    src: 'fetchRecentlyPlayedContent',
                    onDone: {
                      target: 'updatedRp',
                      actions: {
                        type: 'batchLayoutOperations',
                        data: '$event.data.updates',
                        meta: {
                          selectors: ['$action.data'],
                        },
                      },
                    },
                  },
                },
                updatedRp: {
                  after: {
                    0: {
                      target: 'idle',
                      actions: {
                        type: 'save',
                        data: {
                          rpFirstLoad: false,
                        },
                      },
                    },
                  },
                },
              },
              on: {
                LAYOUT_CHANGE_END: {
                  target: 'off',
                  cond: 'isControllerDisabled_recentlyPlayed',
                },
                RP_RERENDER: 'on',
              },
            },
          },
        },
        searchController: {
          initial: 'off',
          states: {
            off: {
              on: {
                VIEW_HEADER_SEARCH_CLICK: {
                  actions: 'nav_HANDLE_CHANGE',
                },
                LAYOUT_CHANGE_END: {
                  target: 'on',
                  cond: 'isControllerEnabled_search',
                },
              },
            },
            on: {
              entry: ['trackOpenSearch'],
              initial: 'initializing',
              states: {
                initializing: {
                  initial: 'prepareInputConfig',
                  states: {
                    prepareInputConfig: {
                      always: [
                        {
                          actions: [
                            {
                              type: 'prepareSearchInputConfig',
                            },
                            {
                              type: 'setLayoutProperty',
                              data: {
                                path:
                                  'components.SearchHeader.properties.inputConfig',
                                value: '$context.inputConfig',
                              },
                              meta: {
                                selectors: ['$action.data.value'],
                              },
                            },
                          ],
                          target: 'manageHeader',
                        },
                      ],
                    },
                    manageHeader: {
                      always: [
                        {
                          target: 'fetchingRP',
                          actions: [
                            {
                              type: 'setLayoutProperty',
                              data: {
                                path: 'components.Modal.properties.titleKey',
                                value: 'searchTitle',
                              },
                            },
                          ],
                          cond: 'isSearchWithoutGameDetailsPage',
                        },
                        {
                          target: 'fetchingRP',
                        },
                      ],
                    },
                    fetchingRP: {
                      invoke: {
                        src: 'fetchRecentlyPlayedContent',
                        onDone: {
                          target: 'fetchPhrases',
                          actions: {
                            type: 'batchLayoutOperations',
                            data: '$event.data.updates',
                            meta: {
                              selectors: ['$action.data'],
                            },
                          },
                        },
                      },
                    },
                    fetchPhrases: {
                      invoke: {
                        src: 'fetchRecentPhrases',
                        onDone: {
                          target: 'idle',
                          actions: [
                            {
                              type: 'save',
                              data: {
                                recentPhrases: '$event.data.recentPhrases',
                              },
                              meta: {
                                selectors: ['$action.data.recentPhrases'],
                              },
                            },
                            {
                              type: 'batchLayoutOperations',
                              data: '$event.data.updates',
                              meta: {
                                selectors: ['$action.data'],
                              },
                            },
                          ],
                        },
                      },
                    },
                    idle: {
                      on: {
                        VIEW_CATEGORY_GAME_TILE_CLICK: [
                          {
                            actions: [
                              {
                                type: 'updatePhrases',
                              },
                              {
                                type: 'savePhrase',
                              },
                              {
                                type: 'sendAlgoliaAnalytics',
                                data: {
                                  id: '$event.payload.id',
                                },
                                meta: {
                                  selectors: ['$action.data.id'],
                                },
                              },
                              'resetSearchAttempts',
                            ],
                            cond: 'isGameLaunchedFromSearchCategory',
                          },
                          {
                            actions: [
                              {
                                type: 'updatePhrases',
                              },
                              {
                                type: 'savePhrase',
                              },
                              'resetSearchAttempts',
                            ],
                          },
                        ],
                        VIEW_SEARCH_CLEAR_CLICK: 'clearingPhrase',
                        VIEW_SEARCH_SUBHEADER_ITEM_CLICK: 'subcategoryShow',
                        VIEW_SEARCH_RESULTS_CLICK: [
                          {
                            target: 'showingMoreResults',
                            cond: 'isSidebarVisible',
                          },
                          {
                            target: 'showingMoreResults',
                            actions: 'scrollTop',
                          },
                        ],
                        VIEW_SEARCH_CLICK: {
                          target: 'searchingTitle',
                          actions: [
                            {
                              type: 'saveSearchInputType',
                              data: {
                                sourceType: 'Search Input',
                              },
                            },
                          ],
                        },
                        VIEW_SEARCH_CHANGE: {
                          target: 'searchingTitle',
                          actions: [
                            {
                              type: 'saveSearchInputType',
                              data: {
                                sourceType: 'Search Input',
                              },
                            },
                          ],
                        },
                        VIEW_SEARCH_PHRASE_CLICK: {
                          target: 'searchingTitle',
                          actions: [
                            {
                              type: 'saveSearchInputType',
                              data: {
                                sourceType: 'Recent Searches',
                              },
                            },
                          ],
                        },
                        VIEW_SOFT_KEYBOARD_VISIBILITY_CHANGED: {
                          actions: [
                            {
                              type: 'setLayoutProperty',
                              data: {
                                path:
                                  'components.ContentWrapper.properties.behavior',
                                value: '$event.payload.behavior',
                              },
                              meta: {
                                selectors: ['$action.data.value'],
                              },
                            },
                          ],
                        },
                        VIEW_RECENT_SEARCHES_CLEAR_CLICK:
                          'clearingRecentSearches',
                        SESSION_STATE_LOGGED_OUT: 'manageUserPhrases',
                        SESSION_STATE_LOGGED_IN: 'manageUserPhrases',
                      },
                    },
                    clearingRecentSearches: {
                      entry: [
                        {
                          type: 'save',
                          data: {
                            recentPhrases: [],
                            phrasePendingAdditionToRecentPhrases: '',
                          },
                        },
                      ],
                      invoke: {
                        src: 'setSearchPhrases',
                        onDone: {
                          target: 'idle',
                          actions: [
                            {
                              type: 'batchLayoutOperations',
                              data: '$event.data.updates',
                              meta: {
                                selectors: ['$action.data'],
                              },
                            },
                            {
                              type: 'savePhrase',
                            },
                          ],
                        },
                      },
                    },
                    showingMoreResults: {
                      entry: [
                        'resetSearchAttempts',
                        {
                          type: 'setLayoutProperty',
                          data: {
                            path:
                              'components.Modal.properties.backButtonVisible',
                            value: true,
                          },
                        },
                        {
                          type: 'setLayoutProperty',
                          data: {
                            path:
                              'components.Modal.properties.sidebarBackButtonVisible',
                            value: true,
                          },
                        },
                      ],
                      invoke: {
                        src: 'fetchSearchResultsContent',
                        onDone: {
                          actions: {
                            type: 'batchLayoutOperations',
                            data: '$event.data.updates',
                            meta: {
                              selectors: ['$action.data'],
                            },
                          },
                        },
                      },
                      on: {
                        VIEW_MODAL_BACK_BUTTON_CLICK: 'setSearchResultsView',
                        LAYOUT_CHANGE_END: {
                          cond: 'isControllerEnabled_search',
                          target: 'setSearchResultsView',
                        },
                      },
                    },
                    setSearchResultsView: {
                      invoke: {
                        src: 'setSearchResultsView',
                        onDone: {
                          target: 'idle',
                          actions: {
                            type: 'batchLayoutOperations',
                            data: '$event.data.updates',
                            meta: {
                              selectors: ['$action.data'],
                            },
                          },
                        },
                      },
                    },
                    clearingPhrase: {
                      entry: 'clearSearch',
                      always: 'setSearchResultContent',
                    },
                    searchingTitle: {
                      entry: [
                        {
                          type: 'updateCurrentPhrase',
                          data: {
                            value: '$event.payload.value',
                          },
                          meta: {
                            selectors: ['$action.data.value'],
                          },
                        },
                      ],
                      invoke: {
                        src: 'fetchSearchGames',
                        onDone: {
                          target: 'fetchTableForSearchGames',
                          actions: [
                            {
                              type: 'save',
                              data: {
                                search: '$event.data.search',
                                games: '$event.data.games',
                              },
                              meta: {
                                selectors: [
                                  '$action.data.search',
                                  '$action.data.games',
                                ],
                              },
                            },
                          ],
                        },
                      },
                    },
                    fetchTableForSearchGames: {
                      invoke: {
                        src: 'fetchTableForSearchGames',
                        onDone: {
                          target: 'setSearchResultContent',
                          actions: [
                            {
                              type: 'save',
                              data: '$event.data',
                              meta: {
                                selectors: ['$action.data'],
                              },
                            },
                          ],
                        },
                        onError: {
                          target: 'setSearchResultContent',
                        },
                      },
                    },
                    setSearchResultContent: {
                      invoke: {
                        src: 'setSearchResultsContent',
                        onDone: {
                          target: 'checkingIfTrackSearch',
                          actions: [
                            {
                              type: 'batchLayoutOperations',
                              data: '$event.data.updates',
                              meta: {
                                selectors: ['$action.data'],
                              },
                            },
                          ],
                        },
                      },
                    },
                    checkingIfTrackSearch: {
                      always: [
                        {
                          actions: ['updateSearchAttempts'],
                          target: 'trackSearchResult',
                          cond: 'isSearchPhraseCorrect',
                        },
                        {
                          target: 'idle',
                        },
                      ],
                    },
                    trackSearchResult: {
                      entry: 'trackSearchResult',
                      always: 'idle',
                    },
                    subcategoryShow: {
                      entry: 'showGamesOfMatchingType',
                      always: 'setSearchResultContent',
                    },
                    manageUserPhrases: {
                      invoke: {
                        src: 'fetchRecentPhrases',
                        onDone: {
                          target: 'idle',
                          actions: [
                            {
                              type: 'save',
                              data: {
                                recentPhrases: '$event.data.recentPhrases',
                              },
                              meta: {
                                selectors: ['$action.data.recentPhrases'],
                              },
                            },
                            {
                              type: 'updatePhrases',
                            },
                            {
                              type: 'savePhrase',
                            },
                            {
                              type: 'batchLayoutOperations',
                              data: '$event.data.updates',
                              meta: {
                                selectors: ['$action.data'],
                              },
                            },
                          ],
                        },
                      },
                    },
                  },
                },
              },
              on: {
                LAYOUT_CHANGE_END: [
                  {
                    target: 'off',
                    cond: 'isControllerDisabled_search',
                  },
                  'refreshing',
                ],
                LAYOUT_MODAL_CLOSE: 'off',
              },
            },
            refreshing: {
              always: 'on',
            },
          },
        },
        promotionsController: {
          initial: 'off',
          states: {
            off: {
              on: {
                LAYOUT_CHANGE_END: {
                  target: 'on',
                  cond: 'arePromotionsEnabled',
                },
              },
            },
            on: {
              entry: {
                type: 'batchLayoutOperations',
                data: [
                  {
                    type: 'setLayoutProperty',
                    data: {
                      path: 'components.Modal.properties.titleKey',
                      value: 'promotionTitle',
                    },
                  },
                ],
              },
              initial: 'initializingHeader',
              states: {
                initializingHeader: {
                  always: [
                    {
                      target: 'view_loaded',
                      cond: 'isHeaderInitialized',
                    },
                    {
                      target: 'waitingForHeader',
                    },
                  ],
                },
                waitingForHeader: {
                  invoke: {
                    src: 'waitForHeader',
                  },
                  on: {
                    WH_HEADER_INITIALIZED: 'view_loaded',
                    WH_HEADER_TIMEOUT: 'headerErrored',
                  },
                },
                view_loaded: {
                  invoke: {
                    src: 'watchPromotionsEvents',
                  },
                  initial: 'initializingPromotions',
                  states: {
                    initializingPromotions: {
                      invoke: {
                        src: 'initializePromotions',
                        onDone: [
                          {
                            target: 'locationChangingToDetails',
                            cond: 'isPromotionsDetailsPage',
                          },
                          {
                            target: 'locationChangingToList',
                          },
                        ],
                      },
                    },
                    locationChangingToDetails: {
                      entry: 'showPromotionDetails',
                      always: 'promotionsDetailsVisible',
                    },
                    locationChangingToList: {
                      entry: 'showPromotionsList',
                      always: 'promotionsListVisible',
                    },
                    promotionsListVisible: {
                      entry: {
                        type: 'setLayoutProperty',
                        data: {
                          path: 'components.Modal.properties.backButtonVisible',
                          value: false,
                        },
                      },
                      on: {
                        PROMOTION_DETAILS_DISPLAYED: {
                          actions: [
                            'promotions_updateUrl',
                            'tracking_changePage',
                            'updatePrevPageArray',
                            'updateCurrentPagePath',
                          ],
                          target: 'promotionsDetailsVisible',
                        },
                      },
                    },
                    promotionsDetailsVisible: {
                      entry: {
                        type: 'setLayoutProperty',
                        data: {
                          path: 'components.Modal.properties.backButtonVisible',
                          value: true,
                        },
                      },
                      on: {
                        PROMOTION_LIST_DISPLAYED: {
                          actions: [
                            'updatePrevPageArray',
                            'updateCurrentPagePath',
                            'promotions_updateUrl',
                            'tracking_changePage',
                          ],
                          target: 'promotionsListVisible',
                        },
                        VIEW_MODAL_BACK_BUTTON_CLICK: {
                          actions: ['showPromotionsList'],
                          target: 'goToPreviousPage',
                        },
                      },
                    },
                    goToPreviousPage: {
                      invoke: {
                        src: 'fetchPreviousPageInfo',
                        onDone: {
                          actions: [
                            {
                              type: 'save',
                              data: {
                                previousPageArray:
                                  '$event.data.previousPageArray',
                              },
                              meta: {
                                selectors: ['$action.data.previousPageArray'],
                              },
                            },
                            'updateCurrentPagePath',
                            'promotions_updateUrl',
                          ],
                          target: 'promotionsListVisible',
                        },
                      },
                    },
                  },
                },
                headerErrored: {
                  entry: {
                    type: 'setLayoutProperty',
                    data: {
                      path: 'components.PromotionsBasecamp.properties',
                      value: {
                        error: {
                          message: 'Error occured while loading Promotions',
                        },
                      },
                    },
                  },
                },
              },
              on: {
                LAYOUT_CHANGE_END: [
                  {
                    target: 'off',
                    cond: 'isControllerDisabled_promotions',
                  },
                  {
                    target: 'refreshing',
                  },
                ],
              },
            },
            refreshing: {
              always: 'on',
            },
          },
        },
        gameDetailsController: {
          initial: 'off',
          states: {
            off: {
              on: {
                LAYOUT_CHANGE_END: {
                  target: 'on',
                  cond: 'isControllerEnabled_gameDetails',
                },
              },
            },
            on: {
              entry: [
                'updateSiteTrackingStorageInfo',
                {
                  type: 'setLayoutProperty',
                  data: {
                    path: 'components.Modal.properties.titleKey',
                    value: 'gameInfoTitle',
                  },
                },
                {
                  type: 'setLayoutProperty',
                  data: {
                    path: 'components.GameDetails.properties.callbackMode',
                    value: '$context.callbackMode',
                  },
                  meta: {
                    selectors: ['$action.data.value'],
                  },
                },
                {
                  type: 'setLayoutProperty',
                  data: {
                    path: 'components.GameDetails.properties.callbackMode',
                    value: '$context.callbackMode',
                  },
                  meta: {
                    selectors: ['$action.data.value'],
                  },
                },
              ],
              on: {
                LAYOUT_CHANGE_END: [
                  {
                    target: 'off',
                    cond: 'isControllerDisabled_gameDetails',
                  },
                  {
                    target: 'refreshing',
                  },
                ],
                VIEW_MODAL_BACK_BUTTON_CLICK: {
                  actions: ['goBack'],
                  target: 'off',
                },
              },
            },
            refreshing: {
              always: 'on',
            },
          },
        },
      },
    },
  },
};

export default mainConfig;
